/**
 * Slice 1q §4: which chat this tab shows, told to the hub (`{"watch": id}`),
 * so a running turn's live draft reaches only the tabs showing it. Each view
 * of a chat holds its thread while it's mounted; the newest held wins. A
 * hidden page watches nothing, and its reply so far is fetched again when it
 * shows (`useHubEvents`).
 */

const held: string[] = [];
let send: ((watch: string | null) => void) | null = null;
let hidden = false;

/** What this tab watches now. */
function watched(): string | null {
  return hidden ? null : (held.at(-1) ?? null);
}

const tell = () => send?.(watched());

/** A view shows `threadId`; the returned function lets it go. */
export function holdWatch(threadId: string): () => void {
  held.push(threadId);
  tell();
  return () => {
    const i = held.lastIndexOf(threadId);
    if (i >= 0) held.splice(i, 1);
    tell();
  };
}

/** The hub socket's sender, set on each open (and told what's watched), cleared on close. */
export function setWatchSender(next: ((watch: string | null) => void) | null) {
  send = next;
  tell();
}

/** The page was hidden or shown. */
export function setHidden(next: boolean) {
  if (hidden === next) return;
  hidden = next;
  tell();
}
